import Tabs, { TProps } from './Tabs'
import { TProps as TTabProps } from './Tab'

export type { TProps, TTabProps }
export default Tabs
